import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledDropdownDivider } from "./Dropdown.styles";
import type { DropdownDividerProps } from "./Dropdown.types";

const DropdownDividerComponent = (
  props: DropdownDividerProps,
): ReactElement => {
  const { className, style } = props;

  return <StyledDropdownDivider className={cx(className)} style={style} />;
};

export const DropdownDivider = styled(DropdownDividerComponent)``;
